import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import styled from 'styled-components/native';
import { SccButton } from '@/components/atoms/SccButton';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import BottomSheet from '@/modals/BottomSheet';
import { ChallengeDateFormat } from '@/utils/ChallengeDateFormat';
const ChallengeUpcomingBottomSheet = ({ selectedUpcomingChallenge, onPressConfirmButton, }) => {
    return (_jsxs(BottomSheet, { isVisible: selectedUpcomingChallenge !== undefined, children: [_jsx(Title, { children: "\uC774 \uCC4C\uB9B0\uC9C0\uB294 \uCD94\uD6C4 \uC624\uD508 \uC608\uC815\uC774\uC608\uC694" }), (selectedUpcomingChallenge === null || selectedUpcomingChallenge === void 0 ? void 0 : selectedUpcomingChallenge.startsAt) && (_jsx(Message, { children: `${ChallengeDateFormat.formatUpcomingBottomSheet(selectedUpcomingChallenge === null || selectedUpcomingChallenge === void 0 ? void 0 : selectedUpcomingChallenge.startsAt)} 부터 참여할 수 있어요. 계단을 정복하고 멤버들과 함께 목표를 달성해보세요!` })), _jsx(ButtonContainer, { children: _jsx(ConfirmButton, { text: '확인', textColor: "white", buttonColor: "brandColor", fontFamily: font.pretendardBold, onPress: () => {
                        onPressConfirmButton();
                    }, elementName: "challenge_upcoming_confirm" }) })] }));
};
export default ChallengeUpcomingBottomSheet;
export const Title = styled.Text({
    color: color.black,
    fontSize: 20,
    fontFamily: font.pretendardBold,
    marginTop: 28,
    marginHorizontal: 24,
});
export const Message = styled.Text({
    color: color.black,
    fontSize: 16,
    fontFamily: font.pretendardRegular,
    marginTop: 10,
    marginHorizontal: 24,
});
export const ButtonContainer = styled.View({
    flexDirection: 'row',
    gap: 10,
    paddingVertical: 20,
    paddingHorizontal: 20,
});
export const ConfirmButton = styled(SccButton) `
  flex: 1;
`;
